import Linkify from 'linkify-react'
import { MessageProps } from '../homepage/types'
import { MessageMedia } from '@/api/types'
import { cn } from '@/lib/utils'

export const Message = ({
  body,
  direction,
  media = [],
  className = '',
  clickable = false,
}: MessageProps & { clickable?: boolean }) => {
  const isOutgoing = direction === 'outgoing'
  return (
    <div
      className={cn(
        isOutgoing ? 'text-right' : 'text-left',
        'w-full mb-3',
        className
      )}
    >
      <div
        className={cn(
          isOutgoing
            ? 'text-white border-transparent bg-purple-800 rounded-br-sm'
            : 'bg-white border-border text-foreground rounded-bl-sm',
          'border py-2 px-3 rounded-2xl text-xs sm:leading-snug sm:text-sm inline-block max-w-xs text-left whitespace-pre-line overflow-hidden',
          className
        )}
      >
        {media.length ? (
          <div className={cn(body && 'pb-2')}>
            {media.map((media: MessageMedia) => {
              if (media.contentType.includes('image')) {
                return (
                  <img
                    key={media.url}
                    alt="Image message"
                    className="block w-full rounded-lg"
                    src={media.url}
                  />
                )
              } else if (media.contentType.includes('audio')) {
                return (
                  <audio
                    key={media.url}
                    className="block w-full mb-2 rounded-lg"
                    preload="metadata"
                    controls
                  >
                    <source src={media.url} type={media.contentType} />
                  </audio>
                )
              } else {
                return (
                  <a
                    key={media.url}
                    href={media.url}
                    target="_blank"
                    rel="noreferrer"
                    className="underline break-all"
                  >
                    Attachment.{media.contentType.split('/').pop()}
                  </a>
                )
              }
            })}
          </div>
        ) : null}
        <Linkify
          options={{
            className: cn('underline', !clickable && 'pointer-events-none'),
            target: '_blank',
          }}
        >
          {body}
        </Linkify>
      </div>
    </div>
  )
}
